import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

export const useSettingsIntegrationsForm = defineStore(
  'settingsIntegrationsForm',
  () => formModule({
    fields: {
      token: {
        rules: [{ name: 'required' }],
        label: 'API Key',
      },
    },
  }),
);
